// extracted by mini-css-extract-plugin
export default {"wrapper":"sw","noPadding":"tw","flavor_wrapper":"uw","flavor_button":"vw","vert":"ww","itemContent":"xw","itemName":"yw","blue":"zw","out_of_stock":"Aw","newFlavorBadge":"Bw","fullWidth":"Cw","flavor_button_selected":"Ew","black":"Fw","attribute_wrapper":"Gw","toggle_wrapper":"Hw"};
    if(module.hot) {
      // 1714442369090
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  